import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { fillPieChart } from "../utils/helpers.js";
import { pieChartColors } from "../utils/options.js";
import {
  ChartCard,
  ChartNoDataFound,
  ChartsLegend,
  formatNumber,
  useEffect,
  useState,
} from "@";
import { useVerificationsQuery } from "../utils/queries.js";

const ChartTooltip = ({ active, payload, label, legendItems }) => {
  if (active && payload && payload.length) {
    const legendItem = legendItems.find((item) => item.id === payload[0].name);
    return (
      <div dir="rtl" className="card p-2 text-start dark:text-gray-400">
        <strong>{label}</strong>
        {payload.map((item, index) => (
          <p key={index}>
            <span className="me-2">{legendItem.name}:</span>
            <strong className="inline-block">
              {formatNumber(item.value)}%
            </strong>
          </p>
        ))}
      </div>
    );
  }
  return null;
};

// Chart component to render a PieChart inside a Card
const Chart = ({ title, noSelect, description, legendItems, queryType }) => {
  const [data, setData] = useState([]);
  const [searchDuration, setSearchDuration] = useState(3);

  // Use React Query to fetch verifications data if queryType is provided
  const { data: verificationsData } = useVerificationsQuery(searchDuration, {
    enabled: !!queryType,
  });

  // Fetch data based on the duration
  const fetchData = (value) => {
    setSearchDuration(value);
  };

  useEffect(() => {
    if (queryType && verificationsData) {
      setData(fillPieChart(verificationsData));
    }
  }, [verificationsData, queryType]);

  return (
    <ChartCard
      searchDurationUpdated={fetchData}
      title={title}
      description={description}
      noSelect={noSelect}
    >
      <div className="-mx-2 h-64 lg:-mx-4 xl:h-80">
        {data?.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart width={800} height={600}>
              <Legend content={<ChartsLegend legendItems={legendItems} />} />
              <Tooltip content={<ChartTooltip legendItems={legendItems} />} />

              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={95}
                fill="#8884d8"
                dataKey="value"
              >
                {/* Map data to PieChart cells with corresponding colors */}
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={pieChartColors[index % pieChartColors.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <ChartNoDataFound />
        )}
      </div>
    </ChartCard>
  );
};

export default Chart;
